module.exports = __webpack_public_path__ + "static/media/fb.ce663184.svg";